<template src="./reported-issues.html"></template>
<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import i18n from '@/i18n'
  import Datatable from '@/components/misc/datatable/Datatable'
  import Loader from '@/components/misc/Loader'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import { hasIssueResolveClaim } from '@/router/auth'

  export default {
    name: 'reported-issues',
    components: {
      Datatable,
      Loader,
      ContextHeader
    },
    data () {
      return {
        load: false,
        IssueStatus: {
          ACTIVE: 1,
          CANCELLED: 2,
          RESOLVED: 3,
          UNRESOLVED: 4
        },
        pagedIssuesUrl: '',
        issuesReportsUrl: '',
        statuses: this.IssueStatus,
        issueCategories: [],
        tOptions: {
          checkboxes: false,
          payloadsTotalPropertyName: 'additionalInformation',
          invalidRowMarker: {
            criteria: function (row, statuses) {
              return row['status'] === statuses.CANCELLED || row['status'] === statuses.UNRESOLVED
            }
          },
          highlightedRowMarker: {
            criteria: function (row, statuses) {
              return row['status'] === statuses.RESOLVED
            }
          },
          detailsLink: {
            createLink: function (row) {
              return 'reported-issues/' + row['id']
            }
          }
        }
      }
    },
    computed: {
      tColumns () {
        return [
          {
            columnName: 'resourceId',
            title: i18n.t('issues.reportColumnResourceId'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.resourceId
            }
          },
          {
            columnName: 'companyNumber',
            title: i18n.t('issues.reportColumnCompanyNumber'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.companyNumber
            }
          },
          {
            columnName: 'organizationName',
            title: i18n.t('userAdministration.userOrganizationName'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.organizationName
            }
          },
          {
            columnName: 'username',
            title: i18n.t('userAdministration.userName'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.username
            }
          },
          {
            columnName: 'categoryCyr',
            title: i18n.t('issues.reportColumnCategory'),
            hideSort: true,
            filterType: 'select',
            filterSelectOptions: this.issueCategories,
            cell (row) {
              return row.categoryCyr
            }
          },
          {
            columnName: 'data',
            title: i18n.t('issues.reportColumnData'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.data
            }
          },
          {
            columnName: 'creationDate',
            columnRange: [
              {
                text: i18n.t('invoices.columnDueDateRangeFrom'),
                value: 'creationDate-from'
              },
              {
                text: i18n.t('invoices.columnDueDateRangeTo'),
                value: 'creationDate-to'
              }
            ],
            title: i18n.t('issues.reportColumnCreationDate'),
            filterType: 'date-range',
            hideFilter: true,
            align: 'center',
            cell (row) {
              return null
            }
          },
          {
            columnName: 'closingDate',
            columnRange: [
              {
                text: i18n.t('invoices.columnDueDateRangeFrom'),
                value: 'closingDate-from'
              },
              {
                text: i18n.t('invoices.columnDueDateRangeTo'),
                value: 'closingDate-to'
              }
            ],
            title: i18n.t('issues.reportColumnClosingDate'),
            filterType: 'date-range',
            hideFilter: true,
            align: 'center',
            cell (row) {
              return null
            }
          },
          {
            columnName: 'status',
            title: i18n.t('issues.reportColumnStatus'),
            hideSort: true,
            filterType: 'select',
            filterSelectOptions: [
              { key: i18n.t('issues.reportIssueStatus.0'), value: '' },
              { key: i18n.t('issues.reportIssueStatus.1'), value: 1 },
              { key: i18n.t('issues.reportIssueStatus.2'), value: 2 },
              { key: i18n.t('issues.reportIssueStatus.3'), value: 3 },
              { key: i18n.t('issues.reportIssueStatus.4'), value: 4 }
            ],
            cell (row) {
              return null
            }
          }]
      }
    },
    created () {
      if (hasIssueResolveClaim()) {
        this.issuesReportsUrl = Vue.$config.reporting_api_root + '/' + Vue.$apiConfig.generateIssuesReport
      }
      this.pagedIssuesUrl = Vue.$apiConfig.pagedIssueReportsGet
      this.tOptions.statuses = this.IssueStatus

      this.load = true
      this.$http.get(Vue.$apiConfig.issueCategoriesGet + '/' + 'all')
        .then(response => {
          this.logConsole(response)
          let payload = response.data.payload
          this.issueCategories.push({ key: i18n.t('issues.reportIssueStatus.0'), value: '' })
          for (let i = 0; i < payload.length; i++) { this.issueCategories.push({ key: payload[i].categoryCyr, value: payload[i].categoryCyr }) }
          this.load = false
        }, error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.load = false
        })
    },
    methods: {
      validateBeforeSubmit () {
        this.logConsole('Creating user notification')

        // validate first
        this.createNotification()
      },
      onRowSelected (row) {
        this.selectedNotification = row
        this.$refs.reviewNotificationModal.show()
      },
      createNotification () {
        this.load = true
        this.$http.post(Vue.$apiConfig.userNotificationsCreatePost, this.notification)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.notificationCreated'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      updateNotification (cancelNotification) {
        this.load = true
        if (cancelNotification) { this.selectedNotification.status = this.NotificationStatus.CANCELLED }
        this.$http.post(Vue.$apiConfig.userNotificationsUpdatePost, this.selectedNotification)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.notificationUpdated'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>

  .container {
    padding: 0px;
  }

  @media (min-width: 1400px) {
      .container {
          width: 1360px;
          max-width: 100%;
      }
  }

  @media (min-width: 1680px) {
      .container {
          width: 1640px;
          max-width: 100%;
      }
  }

  @media (min-width: 1920px) {
      .container {
          width: 1860px;
          max-width: 100%;
      }
  }

  @media (min-width: 2560px) {
      .container {
          width: 2460px;
          max-width: 100%;
      }
  }

  @media (min-width: 2880px) {
      .container {
          width: 2620px;
          max-width: 100%;
      }
  }

  @media (min-width: 3840px) {
      .container {
          width: 3550px;
          max-width: 100%;
      }
  }    
  
  .invalid-notification {
    background-color: #f8d7da !important;
  }
  
</style>



// WEBPACK FOOTER //
// ReportedIssues.vue?c9fcf276